import React from "react"
import {
  Step,
  StepContent,
  StepContentProps,
  StepConnector,
  StepProps,
  Stepper,
  StepperProps,
  styled,
  StepConnectorProps,
} from "@mui/material"

export const StepperComponent = styled((props: StepperProps) => (
  <Stepper
    orientation="vertical"
    connector={<StepConnectorComponent />}
    {...props}
  >
    {props.children}
  </Stepper>
))(() => ({
  width: "100%",
}))

export const StepConnectorComponent = styled((props: StepConnectorProps) => (
  <StepConnector {...props} />
))(() => ({
  border: "none",
  margin: 0,
  "&.MuiStepConnector-root": {
    ".MuiStepConnector-line": {
      display: "none",
    },
  },
}))

export const StepComponent = styled((props: StepProps) => (
  <Step {...props}>{props.children}</Step>
))(() => ({}))

export const StepContentComponent = styled((props: StepContentProps) => (
  <StepContent {...props}>{props.children}</StepContent>
))(() => ({
  border: "none",
  margin: "0",
  padding: "0",
}))
